import Icon from '../components/Icon.vue'

Icon.register({
  'draw-polygon': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M384 352c35.3 0 64 28.7 64 64 0 35.3-28.7 64-64 64-23.6 0-44-13-55.1-32h-209.8c-11.1 19-31.5 32-55.1 32-35.3 0-64-28.7-64-64 0-23.6 13-44 32-55.1v-209.8c-19-11.1-32-31.5-32-55.1 0-35.3 28.7-64 64-64 23.6 0 44 13 55.1 32h209.8c11.1-19 31.5-32 55.1-32 35.3 0 64 28.7 64 64s-28.7 64-64 64c-0.3 0-0.7-0.1-1-0.1l-39.2 65.3c5.1 9.2 8.2 19.6 8.2 30.8s-3.2 21.6-8.2 30.8l39.2 65.3c0.3 0 0.7-0.1 1-0.1zM96 360.9c8.1 4.7 18.4 15 23.1 23.1h208.4l-38.5-64.1c-0.3 0-0.7 0.1-1 0.1-35.3 0-64-28.7-64-64s28.7-64 64-64c0.3 0 0.7 0.1 1 0.1l38.5-64.1h-208.4c-4.7 8.1-15 18.4-23.1 23.1v209.8zM272 256c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16-16 7.2-16 16zM400 96c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16zM64 80c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM48 416c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16-16 7.2-16 16zM384 432c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/draw-polygon.js
// module id = 1287
// module chunks = 0